module.exports = __webpack_public_path__ + "img/98.74c2f46c.png";